module.exports = __webpack_public_path__ + "11c813a4d084094b2a9497e0cc19209f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201605_sputnika_1.jpg
// module id = 644
// module chunks = 0